import { JourneyGroupType } from '@vista/omnichannel-components-domain';
export function getHeadingForJourneyGroup(journeyGroup, displayText, i18n) {
    switch (journeyGroup.type) {
        case JourneyGroupType.UpNext:
            return displayText.nextGroupLabel;
        case JourneyGroupType.FoodAndDrink:
            return displayText.itemOnlyGroupLabel;
        case JourneyGroupType.LastWeek:
            return displayText.lastWeekGroupLabel;
        case JourneyGroupType.Monthly:
        default: {
            const { month, year } = journeyGroup;
            if (month === undefined || year === undefined)
                return '';
            const date = new Date(year, month - 1); // Transform month from 1-indexed to 0-indexed
            return i18n.template(displayText.monthGroupFormat, { date });
        }
    }
}
